import TimelineConfiguratorTabBase from "./TimelineConfiguratorTabBase.jsx";
import { PERSISTENCE_STATE_KEYS } from "../../../other/constants/PersistenceStateKeys.jsx";
import { WIDGET_KEYS } from "../../../other/constants/WidgetKeys.jsx";
import { PresetManager } from "@bryntum/schedulerpro";
import { getScheduleInstanceFromViewManager } from "../../../other/utils/otherUtils.jsx";

const TIMESCALES = [
  {
    id: "manyYears",
    name: "Years",
    timelineFormat: '22, 23, 24, 25, 26, 27 ...',
  },
  {
    id: "year",
    name: "Quarters",
    timelineFormat: 'Q1, Q2, Q3, Q4, Q1, Q2, Q3, Q4 ...',
  },
  {
    id: "monthAndYear",
    name: "Months",
    timelineFormat: 'June 2024, July 2024, August 2024 ...',
  },
  {
    id: "weekDateAndMonth",
    name: "Weeks",
    timelineFormat: '01, 08, 15, 22, 29, 05, 12, 19 ...',
  },
  {
    id: "weekAndMonth",
    name: "Weeks",
    timelineFormat: 'May 01, May 08, May 15, May 22 ...',
  },
  {
    id: "weekAndDayLetter",
    name: "Days",
    timelineFormat: 'S, M, T, W, T, F, S ...',
  },
  {
    id: "weekAndDay",
    name: "Days",
    timelineFormat: '06 May, 07 May, 08 May, 09 May ...',
  },
  {
    id: "dayAndMonth",
    name: "Days",
    timelineFormat: '06, 07, 08, 09, 10, 11, 12, 13, 14 ...',
  },
  {
    id: "dayAndWeek",
    name: "Days",
    timelineFormat: 'Su 06, Mo 07, Tu 08, We 09, Th 10 ...',
  },
  {
    id: "hourAndDay",
    name: "Hours",
    timelineFormat: '1 AM, 2 AM, 3 AM, 4 AM, 5 AM ...',
  },
  {
    id: "minuteAndHour",
    name: "1/2 Hours",
    timelineFormat: '00, 30, 00, 30, 00, 30, 00, 30 ...',
  },
  {
    id: "secondAndMinute",
    name: "Minutes",
    timelineFormat: '00, 10, 20, 30, 40, 50, 00, 10 ...',
  }
];

export default class TimelineConfiguratorTimescalesTab extends TimelineConfiguratorTabBase {
  static get $name() {
    return "TimelineConfiguratorTimescalesTab";
  }
  static get type() {
    return "timelineconfiguratortimescalestab";
  }

  get stateId() {
    return PERSISTENCE_STATE_KEYS.timelineConfiguratorEditorTimescaleGridState;
  }

  static get configurable() {
    return {
      title: "Timescales",
      items: {
        timeScalesGrid: {
          height: "100%",
          type: WIDGET_KEYS.swivuGrid,
          features: {
            cellMenu: false,
            headerMenu: false,
            sort: false,
            group: false
          },
          selectionMode: {
            multiSelect: false,
            cell: false,
            column: false,
          },
          columns: [
            {
              type: "widget",
              text: "",
              id: "checkRadio",
              width: "1em",
              widgets: [{
                type: "radio",
                name: "gridRadio",
                color: 'b-blue',
                cls: "swivu-timeScale-radio !mx-[auto]",
                listeners: {
                  change: "up.selectionChange"
                }
              }]
            },
            {
              id: "timescale",
              field: "name",
              text: "Timescale",
              flex: 1,
              editor: false,
            },
            {
              id: "timescaleFormat",
              field: "timeResolution",
              text: "Timescale Format",
              flex: 1,
              editor: false,
            }
          ],
          bbar: {
            items: {
              doneButton: {
                type: "button",
                icon: "fa-light fa-close",
                text: "Done",
                cls: 'bg-[transparent] text-[#3884e1] border-[1.5px] !rounded-md',
                onClick: "up.close",
              },
            }
          }
        }
      }
    };
  }

  loadRecord(record, context, otherParams) {
    this.context = context;
    super.loadRecord(record, context, otherParams);

    const { timeScalesGrid } = this.widgetMap;
    timeScalesGrid.stateId = this.stateId;

    const presets = TIMESCALES.map((timeScale) => ({
      id: timeScale.id,
      name: timeScale.name,
      timeResolution: timeScale.timelineFormat,
      gridRadio: false,
    }))

    timeScalesGrid.store.data = presets;
    const schedulerView = getScheduleInstanceFromViewManager(context.viewManager);
    if (schedulerView) {
      const currentPreset = schedulerView.viewPreset;
      let presetId = currentPreset.id;
      // the selected preset may be a variant of base preset, in that case we should extract the base preset id
      if (presetId.includes("-")) {
        const [basePresetId] = presetId.split("-");
        presetId = basePresetId;
      }
      const currentPresetRow = timeScalesGrid.store.getById(presetId);
      if (currentPresetRow) {
        currentPresetRow.gridRadio = true;
      }
    }
  }


  selectionChange({ source, checked, userAction }) {
    if (userAction && checked) {
      const { record } = source.cellInfo
      const { timeScalesGrid } = this.widgetMap;
      const schedulerView = getScheduleInstanceFromViewManager(this.context.viewManager);
      if (schedulerView) {
        const selectedRecord = timeScalesGrid.store.getById(record.id);
        schedulerView.viewPreset = PresetManager.getById(selectedRecord.id);
        schedulerView.scrollToDate(this.context.currentViewRef.current.swivuLastViewportCenterDate, { block: "center" });
      }
    }
  }
}

TimelineConfiguratorTimescalesTab.initClass();
